import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';

/**
 * Popup shown when a user tries to create an estimate but today's gold rate
 * has not been entered yet. Two role variants:
 *  - salesman (or any non-admin/non-cashier): informational, "OK" only
 *  - admin / owner / cashier: "Cancel" + "Update Rate Now" (deep-links to /gold-prices)
 */
export default function GoldRateGateDialog({ open, onOpenChange, userRole, onUpdateNow }) {
  const canFix = ['admin', 'owner', 'cashier'].includes(userRole);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="gold-rate-gate-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
              <AlertTriangle className="w-5 h-5 text-amber-600" />
            </div>
            <DialogTitle className="text-base">Today&apos;s Gold Rate Not Updated</DialogTitle>
          </div>
          <DialogDescription className="pt-3 text-sm text-slate-600 leading-relaxed">
            {canFix
              ? 'Please enter today\u2019s gold rates before creating estimates.'
              : 'Estimates can\u2019t be created until today\u2019s gold rate is entered by the cashier or admin. Please ask them to update today\u2019s rate, then try again.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          {canFix ? (
            <>
              <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="gold-rate-gate-cancel">Cancel</Button>
              <Button
                onClick={() => { onOpenChange(false); onUpdateNow && onUpdateNow(); }}
                className="bg-emerald-600 hover:bg-emerald-700 text-white"
                data-testid="gold-rate-gate-update-now"
              >
                Update Rate Now
              </Button>
            </>
          ) : (
            <Button onClick={() => onOpenChange(false)} data-testid="gold-rate-gate-ok">OK</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
